import { useForm } from "react-hook-form";

export type ReassignFormValues = {
  monitoring_assignment: string;
  comment: string;
};

const DEFAULTS: ReassignFormValues = {
  monitoring_assignment: "",
  comment: "",
};

export function useReassignForm() {
  return useForm<ReassignFormValues>({ defaultValues: DEFAULTS });
}
